import {IConversation} from '@/firebase/chat';
import {createSlice} from '@reduxjs/toolkit';

export interface Chatstate {
  conversations: IConversation[];
  totalUnread: number;
}

const initialState: Chatstate = {
  conversations: [],
  totalUnread: 0
};

const chatSlice = createSlice({
  name: 'appSlice',
  initialState,
  reducers: {
    setConversations(state, action) {
      state.conversations = action.payload;
    },
    setTotalUnread(state, action) {
      state.totalUnread = action.payload;
    }
  }
});

export const {setConversations, setTotalUnread} = chatSlice.actions;
export default chatSlice.reducer;
